var map = {
	"./logo_chatdesk.svg": 212,
	"./logo_customerio.svg": 512,
	"./logo_facebook.svg": 270,
	"./logo_freshdesk.svg": 339,
	"./logo_frontapp.svg": 340,
	"./logo_gladly.svg": 341,
	"./logo_gorgias.svg": 342,
	"./logo_helpscout.svg": 343,
	"./logo_instagram.svg": 271,
	"./logo_kustomer.svg": 344,
	"./logo_salesforce.svg": 513,
	"./logo_shopify.svg": 272,
	"./logo_tiktok.svg": 273,
	"./logo_tiktokads.svg": 514,
	"./logo_trustpilot.svg": 515,
	"./logo_twitter.svg": 345,
	"./logo_whistle.svg": 346,
	"./logo_youtube.svg": 516,
	"./logo_zendesk.svg": 213
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2068;